import { useState } from "react";
import api, { formatErr } from "@/lib/api";
import { useParams, useNavigate, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function ResetPassword() {
  const { token } = useParams();
  const nav = useNavigate();
  const [pwd, setPwd] = useState("");
  const [pwd2, setPwd2] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    if (pwd.length < 6) return setErr("Password must be at least 6 characters");
    if (pwd !== pwd2) return setErr("Passwords don't match");
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pwd });
      setDone(true);
      setTimeout(() => nav("/login"), 2200);
    } catch (e) { setErr(formatErr(e.response?.data?.detail) || "Reset failed"); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 vb-fade-in" data-testid="reset-page">
      <form onSubmit={submit} className="w-full max-w-md vb-card p-8" data-testid="reset-form">
        <Link to="/login" className="vb-link text-sm flex items-center gap-1 mb-3"><ArrowLeft size={14} /> Back to sign in</Link>
        <h2 className="vb-heading text-2xl mb-1" style={{ color: "var(--vb-text-2)" }}>Set a new password</h2>
        <p className="opacity-70 mb-5 text-sm">Choose a strong password. Minimum 6 characters.</p>

        {done ? (
          <div className="vb-pill ok mb-2 w-full" data-testid="reset-done">✓ Password updated. Redirecting to sign in…</div>
        ) : (
          <>
            {err && <div className="vb-pill err mb-3 w-full" data-testid="reset-error">{err}</div>}
            <label className="block text-xs font-semibold mb-1.5 uppercase tracking-wider" style={{ color: "var(--vb-text-2)" }}>New password</label>
            <input data-testid="reset-pwd" type="password" required value={pwd} onChange={(e) => setPwd(e.target.value)} className="vb-input mb-3" placeholder="At least 6 characters" autoComplete="new-password" />
            <label className="block text-xs font-semibold mb-1.5 uppercase tracking-wider" style={{ color: "var(--vb-text-2)" }}>Confirm new password</label>
            <input data-testid="reset-pwd2" type="password" required value={pwd2} onChange={(e) => setPwd2(e.target.value)} className="vb-input mb-5" placeholder="Re-enter the password" autoComplete="new-password" />
            <button type="submit" className="vb-btn w-full" disabled={busy} data-testid="reset-submit">
              {busy ? "Updating…" : "Update password"}
            </button>
          </>
        )}
      </form>
    </div>
  );
}
